export const USER_PRIVILEGE_SUCCESS = 'privilege/on_success';
export const privilegeOnSuccess= data => ({
  type: USER_PRIVILEGE_SUCCESS,
  payload: data
});

export const USER_PRIVILEGE_FAILED = 'privilege/on_failed';
export const privilegeOnFailed = error => ({
  type: USER_PRIVILEGE_FAILED,
  payload: error
});

export const SIDE_MENU_ON_LOAD = 'side_menu/on_load';
export const sideMenuOnLoad = () => ({
  type: SIDE_MENU_ON_LOAD
});

export const SIDE_MENU_ON_LOAD_SUCCESS = 'side_menu/on_load_success';
export const sideMenuOnLoadSuccess = data => ({
  type: SIDE_MENU_ON_LOAD_SUCCESS,
  payload: data
});

export const SIDE_MENU_ON_RESET = 'side_menu/on_reset';
export const sideMenuOnReset = () => ({
  type: SIDE_MENU_ON_RESET
});

export const REQUEST_MESSAGE_LOAD = 'side_menu/on_load';
export const requestMessageOnLoad = () => ({
  type: REQUEST_MESSAGE_LOAD
});

export const REQUEST_MESSAGE_SUCCESS = 'request_message/on_success';
export const requestMessageOnSuccess = data => ({
  type: REQUEST_MESSAGE_SUCCESS,
  payload: data
});